import { render } from "./IconHaikara.vue?vue&type=template&id=8354be14&scoped=true"
import script from "./IconHaikara.vue?vue&type=script&lang=js"
export * from "./IconHaikara.vue?vue&type=script&lang=js"

import "./IconHaikara.vue?vue&type=style&index=0&id=8354be14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8354be14"]])

export default __exports__